<div>
  <label [for]="id" class="block text-sm/6 font-medium text-gray-900">{{ label }}</label>
  <div class="relative">
    <input
      [id]="id"
      type="text"
      [placeholder]="placeholder"
      class="block w-full rounded-md bg-white py-1.5 pr-12 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-1 focus:-outline-offset-1 focus:outline-focus/70 focus:shadow-sm sm:text-sm/6 disabled:text-gray-400 transition duration-300 ease-in-out"
      [attr.readonly]="!allowSearch"
      [value]="searchTerm()"
      (input)="updateSearchTerm($event)"
      [attr.disabled]="control.disabled ? true : null"
      (focus)="toggleDropdown()"
    />
    <button
      type="button"
      [attr.disabled]="control.disabled ? true : null"
      class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-hidden cursor-pointer"
      (click)="toggleDropdown()"
    >
      <svg class="size-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
        <path
          fill-rule="evenodd"
          d="M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <ul
      *ngIf="isOpen()"
      @fadeInOut
      class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm"
      id="options"
      role="listbox"
    >
      <li
        *ngFor="let option of filteredOptions()"
        class="relative py-2 pr-9 pl-3 text-gray-900 select-none cursor-pointer hover:bg-primary/30"
        (click)="selectOption(option.key, option.value)"
      >
        <div class="flex items-center">
          <div *ngIf="isSelected(option.key)" class="mr-2 w-2 h-2 rounded-full transition-colors duration-300 bg-primary"></div>
          <span class="ml-1 truncate">{{ option.value }}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
